module.exports = __webpack_public_path__ + "img/D202009_1.67da0cb4.jpg";